import { render, staticRenderFns } from "./OTable.vue?vue&type=template&id=430e3637&scoped=true&"
import script from "./OTable.vue?vue&type=script&lang=js&"
export * from "./OTable.vue?vue&type=script&lang=js&"
import style0 from "./OTable.vue?vue&type=style&index=0&id=430e3637&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430e3637",
  null
  
)

export default component.exports